import { useCallback, useRef } from 'react';
import { API_POST, useConfig } from '../../api/api';
import { mediaUuid } from './media';
import { attachWatchTracker, isTrackableVideo } from './watchTracking';

// Fire-and-forget report to our own backend (which buffers and batches towards
// the licensing server). keepalive lets the request survive pagehide; errors
// are ignored — resending cumulative ranges later is idempotent anyway.
export const sendWatchReport = (
  config,
  media,
  { sessionUuid, durationSeconds, ranges }
) => {
  if (!config) return;
  try {
    fetch(`${config.API_URL}documentation-media/watch-sessions`, {
      ...API_POST({
        mediaUuid: mediaUuid(media),
        sessionUuid,
        durationSeconds,
        ranges,
      }),
      keepalive: true,
    }).catch(() => {});
  } catch (e) {
    // tracking must never break playback
  }
};

// Callback ref that attaches watch-time tracking to a rendered <video>
export const useWatchTracker = (media) => {
  const config = useConfig();
  const configRef = useRef();
  configRef.current = config;
  const cleanupRef = useRef(null);

  return useCallback(
    (video) => {
      if (cleanupRef.current) {
        cleanupRef.current();
        cleanupRef.current = null;
      }
      if (!video || !isTrackableVideo(media)) return;
      cleanupRef.current = attachWatchTracker(video, (report) =>
        sendWatchReport(configRef.current, media, report)
      );
    },
    [media]
  );
};
